/* Mock Data for BPA Email Gateway - Updated Nov 2024 */
import * as FiIcons from 'react-icons/fi';

export const mockProviders = [
  {
    id: 'prov_1',
    name: 'Emailit',
    status: 'active',
    mode: 'Primary',
    health: 99.9,
    lastTest: '10 mins ago',
    emailsToday: 4250,
    emailsMonth: 125400,
    errorRate: 0.02,
    secretRef: 'vault:emailit_prod_key',
    notes: 'Primary transactional route for all production apps.'
  },
  {
    id: 'prov_2',
    name: 'ZeptoMail',
    status: 'ready',
    mode: 'Backup',
    health: 98.5,
    lastTest: '1 hr ago',
    emailsToday: 0,
    emailsMonth: 12400,
    errorRate: 0.15,
    secretRef: 'vault:zepto_failover_secret',
    notes: 'Backup provider. Manual failover capability ready.'
  },
  {
    id: 'prov_3',
    name: 'Amazon SES',
    status: 'standby',
    mode: 'Standby',
    health: 100,
    lastTest: '2 days ago',
    emailsToday: 0,
    emailsMonth: 0,
    errorRate: 0.00,
    secretRef: 'vault:aws_ses_gateway_iam',
    notes: 'Future replacement for high-volume marketing campaigns.'
  }
];

export const mockEmailPacks = [
  {
    id: 'pack_1',
    name: 'Starter Pack',
    monthlyAllowance: 6000,
    annualAllowance: 72000,
    price: 5,
    cycle: 'Monthly',
    warning: 80,
    block: 100,
    overage: 'Block sending',
    status: 'active'
  },
  {
    id: 'pack_2',
    name: 'Growth Pack',
    monthlyAllowance: 10000,
    annualAllowance: 120000,
    price: 10,
    cycle: 'Monthly',
    warning: 80,
    block: 100,
    overage: 'Allow & Flag',
    status: 'active'
  },
  {
    id: 'pack_3',
    name: 'Premium Pack',
    monthlyAllowance: 25000,
    annualAllowance: 300000,
    price: 20,
    cycle: 'Monthly',
    warning: 80,
    block: 100,
    overage: 'Allow & Flag',
    status: 'active'
  },
  {
    id: 'pack_4',
    name: 'Custom Pack',
    monthlyAllowance: 100000,
    annualAllowance: 1200000,
    price: 0,
    cycle: 'Annual',
    warning: 90,
    block: 100,
    overage: 'Manual upgrade',
    status: 'active'
  },
];

export const mockClients = [
  {
    id: 'cli_1',
    name: 'BPA Internal',
    industry: 'Software',
    status: 'active',
    joined: 'Jan 2024',
    planId: 'pack_4',
    usageDaily: 4250,
    usageMonthly: 85400,
    usageAnnual: 980000,
    dailyLimit: 5000,
    monthlyLimit: 100000,
    annualLimit: 1200000,
    failures: 4,
    bounces: 2,
    complaints: 0,
    suppressed: 12,
    limitHits: 0,
    health: 'Excellent',
    appsCount: 4
  },
  {
    id: 'cli_2',
    name: 'Acme Corp',
    industry: 'Manufacturing',
    status: 'active',
    joined: 'Feb 2024',
    planId: 'pack_2',
    usageDaily: 950,
    usageMonthly: 9800,
    usageAnnual: 45000,
    dailyLimit: 1000,
    monthlyLimit: 10000,
    annualLimit: 120000,
    failures: 45,
    bounces: 12,
    complaints: 1,
    suppressed: 45,
    limitHits: 12,
    health: 'Near Limit',
    appsCount: 2
  },
  {
    id: 'cli_3',
    name: 'Omega Inc',
    industry: 'Finance',
    status: 'paused',
    joined: 'Mar 2024',
    planId: 'pack_1',
    usageDaily: 0,
    usageMonthly: 6200,
    usageAnnual: 12000,
    dailyLimit: 200,
    monthlyLimit: 6000,
    annualLimit: 72000,
    failures: 120,
    bounces: 40,
    complaints: 5,
    suppressed: 88,
    limitHits: 25,
    health: 'Over Limit',
    appsCount: 1
  },
];

export const mockApps = [
  {
    id: 'app_1',
    name: 'BPA Website App',
    clientId: 'cli_1',
    status: 'active',
    origins: 'https://bpasolutions.au',
    provider: 'Emailit',
    dailyLimit: 1000,
    monthlyLimit: 20000,
    fallback: true
  },
  {
    id: 'app_2',
    name: 'Internal CRM Sync',
    clientId: 'cli_1',
    status: 'active',
    origins: 'localhost,10.0.0.*',
    provider: 'Emailit',
    dailyLimit: 500,
    monthlyLimit: 10000,
    fallback: false
  },
  {
    id: 'app_3',
    name: 'Acme Contact Forms',
    clientId: 'cli_2',
    status: 'active',
    origins: 'https://acmecorp.com',
    provider: 'ZeptoMail',
    dailyLimit: 200,
    monthlyLimit: 5000,
    fallback: true
  },
];

export const mockTemplates = [
  {
    id: 'tpl_1',
    key: 'contact_form_admin_alert',
    name: 'Admin Alert: New Contact Form',
    subject: 'New Lead: {{name}}',
    status: 'active',
    allowedApps: ['app_1', 'app_3']
  },
  {
    id: 'tpl_2',
    key: 'otp_verification',
    name: 'OTP Verification Code',
    subject: 'Your Code: {{otp}}',
    status: 'active',
    allowedApps: ['app_1', 'app_2']
  },
  {
    id: 'tpl_3',
    key: 'booking_confirmation',
    name: 'Booking Confirmation',
    subject: 'Confirmed: {{bookingDate}}',
    status: 'active',
    allowedApps: ['app_1']
  }
];

export const mockAPIKeys = [
  {
    id: 'key_1',
    name: 'Production Main',
    clientId: 'cli_1',
    appId: 'app_1',
    environment: 'live',
    status: 'active',
    expiry: '2025-12-31',
    lastUsed: '2 mins ago',
    key: 'bpa_mock_live_key_demo_only_123456789'
  },
  {
    id: 'key_2',
    name: 'Staging Test',
    clientId: 'cli_1',
    appId: 'app_1',
    environment: 'test',
    status: 'active',
    expiry: '2025-06-15',
    lastUsed: '1 hr ago',
    key: 'bpa_mock_test_key_demo_only_987654321'
  }
];

export const mockLogs = [
  {
    id: 'log_1',
    time: '2024-11-20 10:45:02',
    client: 'BPA Internal',
    app: 'BPA Website App',
    template: 'contact_form_admin_alert',
    recipient: 'admin@bpa.au',
    provider: 'Emailit',
    status: 'Delivered',
    requestId: 'req_8f7d9a2b4c',
    type: 'send'
  },
  {
    id: 'log_2',
    time: '2024-11-20 10:44:30',
    client: 'Acme Corp',
    app: 'Acme Contact Forms',
    template: 'contact_form_admin_alert',
    recipient: 'it@acme.com',
    provider: 'Emailit',
    status: 'Bounced',
    requestId: 'req_9a2b4c6e8f',
    type: 'error',
    errorType: 'Hard Bounce',
    errorSummary: 'Recipient address does not exist.',
    fallback: 'None',
    resolved: false
  },
  {
    id: 'log_3',
    time: '2024-11-20 10:43:15',
    client: 'BPA Internal',
    app: 'Internal CRM Sync',
    template: 'otp_verification',
    recipient: 'user@gmail.com',
    provider: 'Emailit',
    status: 'Delivered',
    requestId: 'req_1b3c5d7e9f',
    type: 'send'
  },
  {
    id: 'log_4',
    time: '2024-11-20 10:40:00',
    client: 'Omega Inc',
    app: 'Unknown',
    template: 'N/A',
    recipient: 'test@omega.com',
    provider: 'N/A',
    status: 'Blocked',
    requestId: 'req_3c4d5e6f7a',
    type: 'error',
    errorType: 'Quota Exceeded',
    errorSummary: 'Client annual limit reached.',
    fallback: 'None',
    resolved: true
  },
];

export const mockAuditLogs = [
  {
    id: 'aud_1',
    time: '2024-11-20 11:00:05',
    user: 'Admin (AD)',
    action: 'Vault Unlocked',
    target: 'Secure Vault',
    status: 'Success'
  },
  {
    id: 'aud_2',
    time: '2024-11-20 10:55:20',
    user: 'Admin (AD)',
    action: 'Secret Viewed',
    target: 'Emailit Production Key',
    status: 'Success'
  },
  {
    id: 'aud_3',
    time: '2024-11-20 10:30:12',
    user: 'System',
    action: 'Manual Provider Switch',
    target: 'Emailit -> ZeptoMail',
    status: 'Success'
  },
  {
    id: 'aud_4',
    time: '2024-11-19 16:20:00',
    user: 'Manager (JB)',
    action: 'Limit Changed',
    target: 'Acme Corp Monthly Quota',
    status: 'Success'
  },
  {
    id: 'aud_5',
    time: '2024-11-19 14:15:00',
    user: 'Admin (AD)',
    action: 'API Key Generated',
    target: 'Production Main (BPA Website)',
    status: 'Success'
  },
];

export const mockUsageMetrics = {
  global: {
    daily: 4250,
    dailyLimit: 10000,
    monthly: 137800,
    monthlyLimit: 500000,
    annual: 1250000,
    annualLimit: 6000000
  },
  ai: {
    chatbotDaily: 42,
    chatbotLimit: 100,
    monthlyTokens: 1284,
    tokenLimit: 2000
  },
  rateLimits: {
    perMinute: 600,
    perHour: 25000,
    maxRecipients: 50,
    softWarning: 80,
    hardBlock: 100
  }
};

export const mockSuppressions = [
  {
    id: 'sup_1',
    email: 'bad-actor@spam.com',
    reason: 'Manual Block',
    scope: 'Global',
    date: '2024-10-10',
    source: 'Admin Portal',
    status: 'active'
  },
  {
    id: 'sup_2',
    email: 'jason.b@bounce.me',
    reason: 'Bounced',
    scope: 'App-specific',
    date: '2024-10-12',
    source: 'Acme Forms',
    status: 'active'
  },
  {
    id: 'sup_3',
    email: 'complainer@test.com',
    reason: 'Complaint',
    scope: 'Global',
    date: '2024-10-15',
    source: 'SMTP Feedback',
    status: 'inactive'
  },
];

export const mockSecurityLogs = [
  {
    id: 'sec_1',
    time: '5 mins ago',
    user: 'Admin (AD)',
    action: 'Secret Revealed',
    target: 'Production Main Key',
    status: 'Success'
  },
];

export const mockDashboardStats = {
  vaultStatus: 'Locked',
};

export const mockVaultAudit = mockAuditLogs.filter(a => a.action.includes('Vault') || a.action.includes('Secret'));

export const mockDomainIdentities = [
  {
    domain: 'bpasolutions.au',
    from: 'no-reply@bpasolutions.au',
    client: 'BPA Internal',
    spf: 'Verified',
    dkim: 'Verified',
    dmarc: 'Verified',
    status: 'Active',
    lastChecked: '10 mins ago'
  },
];

export const mockEventLogs = [
  {
    id: 'ev_1',
    time: '10:45:00',
    provider: 'Emailit',
    client: 'BPA Internal',
    type: 'Delivered',
    recipient: 'u***@gmail.com',
    status: 'Success'
  },
  {
    id: 'ev_2',
    time: '10:44:30',
    provider: 'Emailit',
    client: 'Acme Corp',
    type: 'Bounced',
    recipient: 'x***@test.com',
    status: 'Permanent'
  },
];

export const mockScheduledEmails = [
  {
    id: 'sch_1',
    appId: 'app_1',
    templateId: 'tpl_3',
    recipient: 'john@example.com',
    sendAt: '2024-11-25 10:00',
    timezone: 'AEST',
    status: 'Scheduled'
  },
  {
    id: 'sch_2',
    appId: 'app_2',
    templateId: 'tpl_2',
    recipient: 'sarah@acme.com',
    sendAt: '2024-11-26 14:30',
    timezone: 'UTC',
    status: 'Paused'
  },
  {
    id: 'sch_3',
    appId: 'app_1',
    templateId: 'tpl_1',
    recipient: 'admin@bpa.au',
    sendAt: '2024-11-18 09:00',
    timezone: 'AEST',
    status: 'Sent'
  },
];

export const mockAppSecrets = [
  {
    id: 'sec_auth_1',
    appId: 'app_1',
    type: 'API Key',
    name: 'Frontend Public Key',
    env: 'live',
    value: 'mock_pk_demo_only_7f9c2a4b6c8d0e1f3a5b7c9d1e',
    maskedValue: 'mock_pk_demo_only_*******'
  },
  {
    id: 'sec_auth_2',
    appId: 'app_1',
    type: 'API Key',
    name: 'Backend Secret Key',
    env: 'live',
    value: 'mock_sk_demo_only_9a2b4c6e8f0a1b3c5d7e9f2a4b',
    maskedValue: 'mock_sk_demo_only_*******'
  },
];

export const mockAppConfigs = {
  'app_1': {
    websiteUrl: 'https://bpasolutions.au',
    webhookUrl: 'https://api.bpasolutions.au/v1/webhooks/email',

    adminEmail: 'admin@bpasolutions.au',
    supportEmail: 'support@bpasolutions.au',
    replyTo: 'no-reply@bpasolutions.au',
    successRedirect: 'https://bpasolutions.au/success',
    failureRedirect: 'https://bpasolutions.au/error',
    notes: 'Primary application for website contact forms and automated alerts.'
  },
};

export const mockVaultSecrets = [
  {
    id: 'v_sec_1',
    name: 'Emailit Production Key',
    type: 'Email Provider API Key',
    linkedTo: 'Emailit (Primary)',
    env: 'live',
    status: 'active',
    value: 'mock_emailit_key_demo_only_123456789',
    lastUpdated: '2024-10-15',
    lastViewed: '2 mins ago',
    usedBy: 'Core Router',
    notes: 'Primary transactional route'
  },
  {
    id: 'v_sec_2',
    name: 'OpenAI GPT-4 Integration',
    type: 'LLM API Key',
    linkedTo: 'BPA AI Assistant',
    env: 'live',
    status: 'active',
    value: 'mock_openai_key_demo_only_abcdef12345',
    lastUpdated: '2024-11-01',
    lastViewed: '1 day ago',
    usedBy: 'AI Agent Service',
    notes: 'Used for email classification'
  }
];